module.exports = __webpack_public_path__ + "img/product7.f48045bf.png";